import type {CSS} from '@pinecast/styles';
import styled from '@pinecast/styles';
import type * as React from 'react';
import type {JSX} from 'react';

const Wrapper = styled('div', {
  alignItems: 'inherit',
  display: 'inline-flex',
});

// For a group that is a widget of its own, such as a radio group: its name,
// description and state, and its keyboard handling, go on the group element.
type WidgetProps = {
  'aria-describedby'?: string;
  'aria-invalid'?: true;
  'aria-label'?: string;
  'aria-labelledby'?: string;
  id?: string;
  onKeyDown?: React.KeyboardEventHandler<HTMLElement>;
  role?: 'radiogroup';
};

export type GroupProps = WidgetProps & {
  allowWrap?: boolean;
  centerChildren?: boolean;
  children: JSX.Element | Array<JSX.Element | boolean | null | undefined>;
  spacing: number;
  // style?: CSS;
  verticalSpacing?: number;
  wrapperStyle?: CSS;
};

const Group = ({
  allowWrap,
  centerChildren,
  children,
  spacing,
  // style,
  verticalSpacing = spacing,
  wrapperStyle,
  ...widgetProps
}: GroupProps) => (
  <Wrapper
    {...widgetProps}
    style={{
      alignItems: centerChildren ? 'center' : undefined,
      flexWrap: allowWrap ? 'wrap' : undefined,
      gap: `${verticalSpacing}px ${spacing}px`,
      verticalAlign: centerChildren ? 'middle' : undefined,
      ...wrapperStyle,
    }}
  >
    {children}
  </Wrapper>
);

export default Group;

export const VerticalGroup = ({
  // A column does not wrap.
  allowWrap: _allowWrap,
  centerChildren,
  children,
  spacing,
  // style,
  wrapperStyle,
  ...widgetProps
}: Omit<GroupProps, 'verticalSpacing'>) => (
  <Wrapper
    {...widgetProps}
    style={{
      alignItems: centerChildren ? 'center' : 'flex-start',
      display: 'flex',
      flexDirection: 'column',
      gap: `${spacing}px`,
      ...wrapperStyle,
    }}
  >
    {children}
  </Wrapper>
);
